// extracted by mini-css-extract-plugin
export default {"verifyContainer":"verifyAccount_verifyContainer__RPtNg","successMessage":"verifyAccount_successMessage__rccus","errorMessage":"verifyAccount_errorMessage__Lv+UC"};